export enum UserProfileField {
    DATE_OF_BIRTH = 'dateOfBirth',
    NAME = 'name',
}
